const API_KEY = process.env.REACT_APP_AWS_FRIENDZ_API_KEY;
const API_BASE_URL = 'https://albvg9jakf.execute-api.us-east-1.amazonaws.com/test';

export const fetchPropertyData = async (propertyAddress, userId = null) => {
  // Serialize address and userId to query string parameters
  const params = { propertyAddress };
  if (userId) params.userId = userId;
  const queryParams = new URLSearchParams(params).toString();
  
  // Construct the URL with the query parameters
  const url = `${API_BASE_URL}/property_roi?${queryParams}`;

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': API_KEY
    }
  };

  try {
    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch {
        const errorText = await response.text();
        errorData = { error: errorText };
      }
      
      // Handle specific status codes gracefully
      if (response.status === 429) {
        throw new Error(`Monthly limit reached: ${errorData.error || 'Upgrade your plan to continue'}`);
      }
      
      throw new Error(errorData.error || `Network response was not ok: ${response.status}`);
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error('Error during fetch:', error);
    throw error;
  }
};

export const recalculateROI = async (formData, userId = null) => {
  // Serialize formData and userId to query string parameters
  const params = { ...formData };
  if (userId) params.userId = userId;
  const queryParams = new URLSearchParams(params).toString();
  
  // Construct the URL with the query parameters
  const url = `${API_BASE_URL}/property_roi?${queryParams}`;

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': API_KEY
    }
  };

  try {
    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch {
        const errorText = await response.text();
        errorData = { error: errorText };
      }
      
      // Handle specific status codes gracefully
      if (response.status === 429) {
        throw new Error(`Monthly limit reached: ${errorData.error || 'Upgrade your plan to continue'}`);
      }
      
      throw new Error(errorData.error || `Network response was not ok: ${response.status}`);
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error('Error during fetch:', error);
    throw error;
  }
};
